import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'

export type TabSlidingUnderlineMetrics = {
    x: number
    width: number
}

export const useTabSlidingUnderline = (activeIndex: number) => {
    const itemRefs = useRef<(HTMLDivElement | null)[]>([])
    const [underline, setUnderline] = useState<TabSlidingUnderlineMetrics>({ x: 0, width: 0 })

    const updateUnderline = useCallback(() => {
        const tabRow = itemRefs.current[0]?.parentElement
        const el = itemRefs.current[activeIndex]
        if (!tabRow || !el) {
            return
        }
        const rowRect = tabRow.getBoundingClientRect()
        const elRect = el.getBoundingClientRect()
        setUnderline({ x: elRect.left - rowRect.left, width: elRect.width })
    }, [activeIndex])

    useLayoutEffect(() => {
        updateUnderline()
    }, [updateUnderline])

    useEffect(() => {
        const tabRow = itemRefs.current[0]?.parentElement
        if (!tabRow) {
            return
        }
        const ro = new ResizeObserver(() => updateUnderline())
        ro.observe(tabRow)
        window.addEventListener('resize', updateUnderline)
        return () => {
            ro.disconnect()
            window.removeEventListener('resize', updateUnderline)
        }
    }, [updateUnderline])

    const setItemRef = useCallback(
        (index: number) => (el: HTMLDivElement | null) => {
            itemRefs.current[index] = el
        },
        []
    )

    return { underline, setItemRef }
}
